export default {
  'meta.collectDate': {
    ko: '수집 일자',
    ja: '収集日',
    en: 'Date of collection',
    cn: '',
  },
  'meta.metaData': {
    ko: '메타 데이터',
    ja: 'メタデータ',
    en: 'Meta Data',
    cn: '',
  },
  'meta.collectReason': {
    ko: '수집 사유',
    ja: '収集事由',
    en: 'Reason for collection',
    cn: '',
  },
  'meta.count': {
    ko: '데이터 건수',
    ja: 'データ数',
    en: 'Number of data',
    cn: '',
  },
  'meta.reason.q': {
    ko: '데이터를 수집하시겠습니까? 수집 사유를 입력하세요.',
    ja: 'データを収集しますか？収集事由を入力してください。',
    en: 'Do you want to collect data? Enter the reason for collection.',
    cn: '',
  },
  'meta.descriptions': {
    ko: '상세 보기',
    ja: '詳細ビュー',
    en: 'Descriptions View',
    cn: '',
  },
  'meta.collect.delete': {
    ko: '메타 데이터 삭제',
    ja: 'メタデータを削除',
    en: 'Delete metadata.',
    cn: '',
  },
  'meta.collection': {
    ko: '수집',
    ja: '収集',
    en: 'collection',
    cn: '',
  },
  // BEGIN::Added.by.KWShin.2025.10.02.
  'meta.delete.batch.q': {
    ko: 'Batch job 데이터를 삭제하시겠습니까? Batch job 이력이 포함되어 있으며 삭제 시 복구가 불가능하므로 특별한 경우가 아닌 한 삭제하지 마십시오. 확인 시 데이터가 삭제됩니다.',
    en: 'Will you really delete batch job data? You should not delete this data because it include history data and can not be recovered. If you click Yes, the data will be earsed',
  },
  // FINISH::Added.by.KWShin.2025.10.02.
};
